// Module
var code = "<p>Enable this setting to allow your respondents to share the Public results through a link.</p> ";
// Exports
module.exports = code;